import Thumbor from './thumbor'

export default (config) => {
  config.schema = config.ssl ? 'https://' : 'http://'
  config.apiServerUrl = `${config.schema}${config.apiServer}${
    config.apiServerPrefix ? `/${config.apiServerPrefix}` : ''
  }`
  config.socketServerUrl = `${config.ssl ? 'wss://' : 'ws://'}${config.apiServer}${
    config.socketServerPrefix ? `/${config.socketServerPrefix}` : ''
  }`
  config.files.staticServerUrl = config.schema + config.files.staticServer
  config.files.thumbServerUrl = config.schema + config.files.thumbServer

  config.files.createStaticUrl = function (src) {
    return `${config.files.staticServerUrl}/${
      config.files.prefixUrl || ''
    }${src}`
  }

  config.files.thumbor = new Thumbor(config)

  return config
}
